// HTML entities / typography units
export const SUP2 = String.fromCharCode(178);
export const SUP3 = String.fromCharCode(179);
export const NBSP = String.fromCharCode(160);

export const SQUARE_METERS_UNIT = `m${SUP2}`;
export const CUBIC_METERS_UNIT = `m${SUP3}`;
// HTML entities / typography units
export const SUP2 = String.fromCharCode(178);
export const SUP3 = String.fromCharCode(179);
export const NBSP = String.fromCharCode(160);

export const SQUARE_METERS_UNIT = `m${SUP2}`;
export const CUBIC_METERS_UNIT = `m${SUP3}`;
